export default __webpack_public_path__ + "static/media/home-swarovski-banner-comp.a8a833b1.jpg";